import { Nullable } from "@/general/custom-types/CustomTypes";

export class AssignWorkPeriod {
  id: Nullable<number>;
  workPeriod: Nullable<number>;
  facilities: number[];
  locations: number[];

  constructor(
    id: Nullable<number> = null,
    workPeriod: Nullable<number> = null,
    objects: number[] = [],
    locations: number[] = []
  ) {
    this.id = id;
    this.workPeriod = workPeriod;
    this.facilities = objects;
    this.locations = locations;
  }
}
